module.exports = __webpack_public_path__ + "img/desc1.9377f6bc.png";